import BriefGuide from '@elem/compCommon/ProductConstructor/BriefGuide';
import ProductMenu from '@elem/compCommon/ProductConstructor/Menu';
import ProductBundles from '@elem/compCommon/ProductConstructor/Bundles';
import ProductSupport from '@elem/compCommon/ProductConstructor/Support';
import ProductSpecs from '@elem/compCommon/ProductConstructor/Specs';
import ProductMedia from '@elem/compCommon/ProductConstructor/Media';
import { createPortal } from 'react-dom';
import QuoteWinFloat from '@elem/compCommon/ProductConstructor/BriefGuide/Info/QuoteWinFloat';
import QuoteWin from '@elem/compCommon/ProductConstructor/BriefGuide/Info/QuoteWin';
import ContrastTable from '@elem/compCommon/ProductConstructor/BriefGuide/ContrastTable';
import InstallationPopup from '@elem/compCommon/ProductConstructor/BriefGuide/InstallationPopup';
import BundlePopup from './../../DeltaProUltra/Launch/BundlePopup';
import ProductDetail from './Detail';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { useSupportData } from '@/utils/hooks';
import { getProductMsg, getProductFromGeneralKey } from '@/utils/productGetServerSideProps';
import EcoLink from 'eco-design/base/eco-link';

// 产品详情页参数
// const generalKey = 'product_ps_delta_delta_max';
const generalKey = 'product_home_pd303';
export default function SmartHomePanel2({ theme }: any) {
    const { useState, useEffect, useRouter, gloproductlist, useLang } = useGlobal();
    const router = useRouter();
    const { locale, query } = router;
    const LOCAL_SITES: string[] = ['ca'];
    const [isClient, setIsClient] = useState(false);
    const [showBundlePop, setShowBundlePop] = useState(false);

    const [supportActive, setSupportActive] = useState('');
    const [feePop, setFeePop] = useState(false);
    const [bundlePopupKey, setBundlePopupKey] = useState(-1);

    const [showQuote, setShowQuote] = useState(false);

    // 从全局的列表中--获取产品详情的基本信息
    const productMsg = getProductFromGeneralKey({ gloproductlist, generalKey: generalKey });
    // // 如果不存在该页面,返回404
    // if (Object.keys(productMsg).length <= 0 && typeof window !== 'undefined') {
    //     return router.push(`/404`);
    // }

    const [resProductCatagory, productDetail, supportData] = useSupportData(getProductMsg, locale, productMsg, productMsg?.spuId || productMsg?.sourceId);

    const data: any = {
        langKey: 'smart_home_panel_2.launch',
        briefGuide: {
            swiper: [
                // '/responsive/video/smart-home-panel-2/launch/swiper1.mp4',
                { img: '/responsive/picture/smart-home-panel-2/launch/swiper1.png', imgPad: '/responsive/picture/smart-home-panel-2/launch/swiper1_768.png' },
                {
                    img:
                        locale === 'ca'
                            ? 'https://websiteoss.ecoflow.com/upload/image/1748931117166/shp2-2.png'
                            : `/responsive/picture/smart-home-panel-2/launch/swiper2${LOCAL_SITES?.includes(locale) ? `_${locale}` : '_back'}.png`,
                    imgPad:
                        locale === 'ca'
                            ? 'https://websiteoss.ecoflow.com/upload/image/1748931117166/shp2-2.png'
                            : `/responsive/picture/smart-home-panel-2/launch/swiper2_768${LOCAL_SITES?.includes(locale) ? `_${locale}` : '_back'}.png`,
                },
                { img: '/responsive/picture/smart-home-panel-2/launch/swiper6.jpg', imgPad: '/responsive/picture/smart-home-panel-2/launch/swiper6_768.jpg' },
                { img: '/responsive/picture/smart-home-panel-2/launch/swiper3.jpg', imgPad: '/responsive/picture/smart-home-panel-2/launch/swiper3_768.jpg' },
                { img: '/responsive/picture/smart-home-panel-2/launch/swiper4.jpg', imgPad: '/responsive/picture/smart-home-panel-2/launch/swiper4_768.jpg' },
                { img: '/responsive/picture/smart-home-panel-2/launch/swiper5.jpg', imgPad: '/responsive/picture/smart-home-panel-2/launch/swiper5_768.jpg' },
            ],
            info: {
                title: 'brief_guide.info.title',
                desc: 'brief_guide.info.desc',
                textArr: ['brief_guide.info.text1', 'brief_guide.info.text2', 'brief_guide.info.text3', 'brief_guide.info.text4', 'brief_guide.info.text5'],
                productId: (() => {
                    const map: any = {
                        us: '6964802453577',
                        ca: '8006700236954',
                        mx: '7704625283151',
                    };
                    return map[locale] || map.us;
                })(),
                variantId: (() => {
                    const map: any = {
                        us: '40758830071881',
                        ca: '44244774650010',
                        mx: '42614296707151',
                    };
                    return map[locale] || map.us;
                })(),
                code: 'brief_guide.info.code',
                codeId: 'brief_guide.info.codeId',
            },
            popup: [
                { question: 'brief_guide.popup.q1', answer: 'brief_guide.popup.a1', img: '/responsive/picture/smart-home-panel-2/launch/popup_1.jpg' },
                { question: 'brief_guide.popup.q2', answer: 'brief_guide.popup.a2' },
                { question: 'brief_guide.popup.q3', answer: 'brief_guide.popup.a3' },
                { question: 'brief_guide.popup.q4', answer: 'brief_guide.popup.a4' },
            ],
        },
        bar: {
            text: 'bar.text',
            auto_copy: 'bar.auto_copy',
            codeId: 'brief_guide.info.codeId',
        },
        menu: {
            title:
                query?.withHeader !== '1'
                    ? 'menu.shp2'
                    : [
                          { product: 'menu.dpu', url: `/${locale}${query?.back ? query.back : '/delta-pro-ultra'}` },
                          { product: 'menu.shp2', url: `/${locale}/smart-home-panel-2?withHeader=1` },
                      ],
        },
        bundles: {
            data: [
                {
                    title: 'bundles.bundle1_title',
                    name: 'bundles.bundle1_name',
                    power: 'bundles.bundle1_power',
                    desc: 'bundles.bundle1_desc',
                    // img: `/responsive/picture/common-products/bundle_intelligent_kit${locale === 'us' ? '_us' : ''}.png`,
                    img: `/responsive/picture/common-products/bundle_intelligent_kit.png`,
                    link: locale === 'us' ? { type: 1, text: 'How Does It Work?' } : '',
                    install: locale === 'us',
                    productId: (() => {
                        const localMap: any = {
                            us: '6972484026441',
                            ca: '8006700236954',
                        };
                        return localMap[locale] || localMap.us;
                    })(),
                    variantId: (() => {
                        const localMap: any = {
                            us: '40790304063561',
                            ca: '44244774682778',
                        };
                        return localMap[locale] || localMap.us;
                    })(),
                    subs: ['us', 'ca'].includes(locale)
                        ? [
                              {
                                  subtitle: 'bundles.subs.subtitle',
                                  title: 'bundles.subs.battery',
                                  img: '/responsive/picture/common-products/DPU_Battery.png',
                                  limit: 4,
                                  parentVariantId: (() => {
                                      const localMap: any = {
                                          us: '40790304063561',
                                          ca: '44244774682778',
                                      };
                                      return localMap[locale] || localMap.us;
                                  })(),
                                  productId: (() => {
                                      const LocalMap: any = {
                                          us: '6965707112521',
                                          ca: '8012436209818',
                                      };
                                      return LocalMap[locale] || LocalMap.us;
                                  })(),
                                  variantId: (() => {
                                      const LocalMap: any = {
                                          us: '41446274465865',
                                          ca: '44960085639322',
                                      };
                                      return LocalMap[locale] || LocalMap.us;
                                  })(),
                              },
                          ]
                        : null,
                    // 安装服务的搭售
                    installs: [
                        {
                            subtitle: 'bundles.installs.subtitle',
                            title: 'bundles.installs.install_title',
                            img: '',
                            link: (() => {
                                const LocalMap: any = {
                                    us: 'https://us.ecoflow.com/products/installation-service',
                                };
                                return LocalMap[locale];
                            })(),
                            parentVariantId: (() => {
                                const localMap: any = {
                                    us: '40790304063561',
                                };
                                return localMap[locale] || localMap.us;
                            })(),
                            productId: (() => {
                                const LocalMap: any = {
                                    us: '15343862284361',
                                };
                                return LocalMap[locale];
                            })(),
                            variantId: (() => {
                                const LocalMap: any = {
                                    us: '54527686869065',
                                };
                                return LocalMap[locale];
                            })(),
                        },
                    ].filter((i) => i.productId),
                },
                {
                    title: 'bundles.bundle2_title',
                    name: 'bundles.bundle2_name',
                    power: 'bundles.bundle2_power',
                    desc: 'bundles.bundle2_desc',
                    img: '/responsive/picture/common-products/bundle_smart_home_panel_2.png',
                    install: locale === 'us',
                    productId: (() => {
                        const localMap: any = {
                            us: '6964802486345',
                            ca: '8006700761242',
                        };
                        return localMap[locale] || localMap.us;
                    })(),
                    variantId: (() => {
                        const localMap: any = {
                            us: '40767883575369',
                            ca: '44244781531290',
                        };
                        return localMap[locale] || localMap.us;
                    })(),
                    // 安装服务的搭售
                    installs: [
                        {
                            subtitle: 'bundles.installs.subtitle',
                            title: 'bundles.installs.install_title',
                            img: '',
                            link: (() => {
                                const LocalMap: any = {
                                    us: 'https://us.ecoflow.com/products/installation-service',
                                };
                                return LocalMap[locale];
                            })(),
                            parentVariantId: (() => {
                                const localMap: any = {
                                    us: '40767883575369',
                                };
                                return localMap[locale] || localMap.us;
                            })(),
                            productId: (() => {
                                const LocalMap: any = {
                                    us: '15343862284361',
                                };
                                return LocalMap[locale];
                            })(),
                            variantId: (() => {
                                const LocalMap: any = {
                                    us: '54527686869065',
                                };
                                return LocalMap[locale];
                            })(),
                        },
                    ].filter((i) => i.productId),
                },
                {
                    title: 'bundles.bundle3_title',
                    name: 'bundles.bundle3_name',
                    power: 'bundles.bundle3_power',
                    desc: 'bundles.bundle3_desc',
                    ship: 'bundles.bundle3_ship',
                    install: locale == 'us',
                    link: locale === 'us' ? { type: 2, text: 'How Does It Work?' } : '',
                    // 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719802008133/test2.png'
                    img:
                        locale === 'jp'
                            ? '/responsive/picture/delta-pro-ultra/launch/bundle2_jp.png'
                            : locale === 'us'
                            ? 'https://websiteoss.ecoflow.com/upload/image/1727055464404/hassle-free.png'
                            : '/responsive/picture/common-products/bundle_smart_control_kit.png',
                    productId: (() => {
                        const localMap: any = {
                            jp: '7835103494305',
                            us: '7013514936393',
                        };
                        return localMap[locale] || undefined;
                    })(),
                    variantId: (() => {
                        const localMap: any = {
                            jp: '43695279997089',
                            us: '40944017440841',
                        };
                        return localMap[locale] || undefined;
                    })(),
                    subs: ['us'].includes(locale)
                        ? [
                              {
                                  subtitle: 'bundles.subs.subtitle',
                                  title: 'bundles.subs.battery',
                                  img: '/responsive/picture/common-products/DPU_Battery.png',
                                  limit: 4,
                                  parentVariantId: (() => {
                                      const localMap: any = {
                                          us: '40944017440841',
                                      };
                                      return localMap[locale] || undefined;
                                  })(),
                                  productId: (() => {
                                      const LocalMap: any = {
                                          us: '6965707112521',
                                      };
                                      return LocalMap[locale] || LocalMap.us;
                                  })(),
                                  variantId: (() => {
                                      const LocalMap: any = {
                                          us: '41446274465865',
                                      };
                                      return LocalMap[locale] || LocalMap.us;
                                  })(),
                              },
                          ]
                        : null,
                },
                {
                    title: 'bundles.bundle4_title',
                    name: locale === 'us' ? undefined : 'bundles.bundle4_name',
                    power: 'bundles.bundle4_power',
                    desc: 'bundles.bundle4_desc',
                    install: locale === 'us',
                    link: { type: 3, text: 'Learn More >' },
                    productId: (() => {
                        const localMap: any = {
                            us: '7199648972873',
                            ca: '8233477046426',
                        };
                        return localMap[locale] || localMap.us;
                    })(),
                    variantId: (() => {
                        const localMap: any = {
                            us: '41410973958217',
                            ca: '44906482303130',
                        };
                        return localMap[locale] || localMap.us;
                    })(),
                    subs: ['ca'].includes(locale)
                        ? [
                              {
                                  subtitle: 'bundles.subs.subtitle',
                                  title: 'bundles.subs.ExtraBattery',
                                  limit: 4,
                                  parentVariantId: (() => {
                                      const localMap: any = {
                                          ca: '44906482303130',
                                      };
                                      return localMap[locale] || localMap.ca;
                                  })(),
                                  productId: (() => {
                                      const LocalMap: any = {
                                          ca: '8231518666906',
                                      };
                                      return LocalMap[locale] || LocalMap.ca;
                                  })(),
                                  variantId: (() => {
                                      const LocalMap: any = {
                                          ca: '44902577209498',
                                      };
                                      return LocalMap[locale] || LocalMap.ca;
                                  })(),
                              },
                          ]
                        : null,
                    // 安装服务的搭售
                    installs: [
                        {
                            subtitle: 'bundles.installs.subtitle',
                            title: 'bundles.installs.install_title',
                            img: '',
                            link: (() => {
                                const LocalMap: any = {
                                    us: 'https://us.ecoflow.com/products/installation-service',
                                };
                                return LocalMap[locale];
                            })(),
                            parentVariantId: (() => {
                                const localMap: any = {
                                    us: '41410973958217',
                                };
                                return localMap[locale] || localMap.us;
                            })(),
                            productId: (() => {
                                const LocalMap: any = {
                                    us: '15343862284361',
                                };
                                return LocalMap[locale];
                            })(),
                            variantId: (() => {
                                const LocalMap: any = {
                                    us: '54527686869065',
                                };
                                return LocalMap[locale];
                            })(),
                        },
                    ].filter((i) => i.productId),
                },
                {
                    title: 'bundles.bundle5_title',
                    power: 'bundles.bundle5_power',
                    desc: 'bundles.bundle5_desc',
                    install: locale === 'us',
                    link: { type: 2, text: 'How Does It Work?' },
                    productId: (() => {
                        const localMap: any = {
                            us: '7199648972873',
                        };
                        return localMap[locale] || localMap.us;
                    })(),
                    variantId: (() => {
                        const localMap: any = {
                            us: '41410973990985',
                        };
                        return localMap[locale] || localMap.us;
                    })(),
                },
            ],
            customize:
                locale === 'us'
                    ? {
                          link: '/customize-bundle-for-shp2',
                          img: '/responsive/picture/common-products/customize_bundle.png',
                      }
                    : null,
            shipping: ['ca'].includes(locale),
        },
        media: {
            mediaBanner: {
                title: 'media.media_title',
                img: '/responsive/picture/delta-pro-ultra/launch/media_banner.jpg',
                imgPad: '/responsive/picture/delta-pro-ultra/launch/media_banner_768.jpg',
            },
            mediaList: [
                {
                    poster: '/responsive/picture/delta-pro-ultra/launch/media0.jpg',
                    title: 'media.list0',
                    link: 'https://www.youtube.com/embed/JcKq6neGxXk?si=XrB0G7e6w7PcrV31',
                },
                {
                    poster: '/responsive/picture/delta-pro-ultra/launch/media1.jpg',
                    title: 'media.list1',
                    link: 'https://www.youtube.com/embed/i__nMuz6M74?si=veweiOuE3qlS4UdM',
                },
                {
                    poster: '/responsive/picture/delta-pro-ultra/launch/media2.jpg',
                    title: 'media.list2',
                    link: 'https://www.youtube.com/embed/WDGzPCrw7FY?si=iRAw9l_sQQ0wQ5Rd',
                },
                {
                    poster: '/responsive/picture/delta-pro-ultra/launch/media3.jpg',
                    title: 'media.list3',
                    link: 'https://www.youtube.com/embed/TeoXospthac?si=QTzTEJ0JK0XKdjP5',
                },
                {
                    poster: '/responsive/picture/delta-pro-ultra/launch/media4.jpg',
                    title: 'media.list4',
                    link: 'https://www.youtube.com/embed/suphdNkkrN4?si=emJrHJgQ80bjsfX7',
                },
                {
                    poster: '/responsive/picture/delta-pro-ultra/launch/media5.jpg',
                    title: 'media.list5',
                    link: 'https://www.youtube.com/embed/_zYHtNnuO-A?si=sTEedcfu_cIb8LRI',
                },
            ],
        },
    };
    const { briefGuide, langKey, bar, menu, bundles, media } = data;
    const { t } = useLang(langKey);

    const hasSupportFlag =
        supportData?.downloadList?.length > 0 || supportData?.videoList?.length > 0 || supportData?.faqList?.length > 0 || supportData?.onlineList?.length > 0;

    const allow_tabs: string[] = ['product', 'bundles', 'support', 'specs', 'media'];
    // const allow_tabs: string[] = ['product', 'bundles'];
    // if (hasSupportFlag) allow_tabs?.push('support');
    // if (resProductCatagory && productDetail) allow_tabs?.push('specs');
    // if (media?.mediaList?.length > 0) allow_tabs?.push('media');
    const [tab, setTab] = useState(query?.tab && allow_tabs.includes(query?.tab?.toLowerCase()) ? query?.tab?.toLowerCase() : allow_tabs[0]);
    const defaultTabObj: any = {
        product: false,
        bundles: false,
        support: false,
        specs: false,
        media: false,
    };
    const [changedTab, setChangedTab] = useState(
        query?.tab && allow_tabs.includes(query?.tab?.toLowerCase())
            ? { ...defaultTabObj, [query?.tab?.toLowerCase()]: true }
            : { ...defaultTabObj, [allow_tabs[0]]: true },
    );

    const handleCallbackLink = (k: number) => {
        setShowBundlePop(k !== 3);
        setBundlePopupKey(k);
    };

    const handleChangeTab = (tab: string) => {
        setTab(tab);
        if (!changedTab[tab]) {
            setChangedTab({ ...changedTab, [tab]: true });
        }
        if (query?.tab) {
            router.push(
                {
                    pathname: router.pathname,
                    query: { tab: tab },
                },
                undefined,
                { shallow: true, replace: true },
            );
        }
        const bar = document.querySelector('.product-announcement-bar') as HTMLElement;
        if (bar) {
            handleScroll(bar);
        }
    };

    const handleChangeTabFromDetail = (obj: any) => {
        const { tab, active } = obj;
        handleChangeTab(tab);
        setSupportActive(active);
    };

    const handleScroll = () => {
        if (typeof window !== 'undefined') {
            const barLine = document.querySelector('.top-bar-line') as HTMLElement;
            const header = document.querySelector('.ecoflow-frame-header') as HTMLElement;
            if (barLine) {
                window.scrollTo({
                    top: barLine?.offsetTop + (header?.offsetHeight || 0),
                    behavior: 'smooth', // 可选，平滑滚动
                });
            }
        }
    };

    useEffect(() => {
        if (typeof window !== 'undefined' && allow_tabs?.includes(query?.tab?.toLowerCase())) {
            const bar = document.querySelector('.product-announcement-bar') as HTMLElement;
            if (bar) {
                handleScroll(); // 初始滚动到指定元素位置
                window.addEventListener('load', handleScroll);
                window.addEventListener('resize', handleScroll);

                return () => {
                    window.removeEventListener('load', handleScroll);
                    window.removeEventListener('resize', handleScroll);
                };
            }
        }
    }, [allow_tabs, query?.tab]);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsClient(true);
        }
    }, []);

    useEffect(() => {
        if (typeof window !== 'undefined' && tab.toLowerCase() === 'bundles' && locale === 'us') {
            const bundles = document.querySelectorAll('.product-bundles .bundles .bundle');
            const toggleBundlePop = () => {
                setShowBundlePop(true);
            };
            if (bundles[2]) {
                const target = bundles[2].querySelector('.bundle-img');
                if (target) {
                    target.style.cursor = 'pointer';
                    target.addEventListener('click', toggleBundlePop);
                    return () => target.removeEventListener('click', toggleBundlePop);
                }
            }
        }
    }, [tab, locale]);

    return (
        <div className={`smart-home-panel-2-launch ${css['smart-home-panel-2-launch']}`}>
            {query?.withHeader === '1' && (
                <>
                    <BriefGuide briefGuide={briefGuide} langKey={langKey} callBuy={() => handleChangeTab('bundles')} feePop={feePop} callFeePop={setFeePop} />
                    <p className="top-bar-line"></p>
                    {/* <ProductAnnouncementBar callTab={handleChangeTab} callPop={setFeePop} /> */}
                </>
            )}
            {query?.widthHeader !== '1' && ['us'].includes(locale) && (
                <>
                    {isClient && <QuoteWinFloat callback={() => setShowQuote(true)} desc={t(briefGuide.info.desc)} />}
                    {showQuote && <QuoteWin callback={() => setShowQuote(false)} />}
                </>
            )}
            <ProductMenu
                langKey={langKey}
                menu={menu}
                activeTab={tab}
                callTab={handleChangeTab}
                info={briefGuide.info}
                // hideTabs={locale === 'us' && query?.back === '/delta-pro-ultra-daily-use' ? ['bundles'] : ['']}
                hideTabs={['mx']?.includes(locale) ? ['bundles'] : ['']}
                buyLink={productMsg?.buyLink || ''}
            />
            {changedTab.product && (
                <div className={`tab-container ${tab === 'product' ? 'active' : ''}`}>
                    <ProductDetail callTab={handleChangeTabFromDetail} />
                </div>
            )}
            {changedTab.bundles && (
                <div className={`tab-container ${tab === 'bundles' ? 'active' : ''}`}>
                    <ProductBundles
                        langKey={langKey}
                        bundles={bundles?.data}
                        customize={bundles?.customize}
                        shipping={bundles?.shipping}
                        callbackLink={handleCallbackLink}
                        buyComponents={(item, Element) => {
                            const IS_CA = locale === 'ca';
                            return (
                                <>
                                    {Element}
                                    {IS_CA && (
                                        <EcoLink className="bundle-learn-more" href={item.link_learn_more}>
                                            Learn More
                                        </EcoLink>
                                    )}
                                </>
                            );
                        }}
                    />
                    {locale === 'us' && <ContrastTable />}
                    {isClient &&
                        showBundlePop &&
                        createPortal(
                            <BundlePopup
                                bundlePopupKey={bundlePopupKey}
                                callback={() => {
                                    setShowBundlePop(false);
                                    setBundlePopupKey(-1);
                                }}
                            />,
                            document.body,
                        )}
                    {isClient &&
                        bundlePopupKey === 3 &&
                        createPortal(
                            <InstallationPopup
                                callInstallation={() => {
                                    setBundlePopupKey(-1);
                                }}
                            />,
                            document.body,
                        )}
                </div>
            )}
            {changedTab.support && hasSupportFlag && (
                <div className={`tab-container ${tab === 'support' ? 'active' : ''}`}>
                    <ProductSupport supportActive={supportActive} supportData={supportData} theme={theme} />
                </div>
            )}
            {changedTab.specs && resProductCatagory && productDetail && (
                <div className={`tab-container ${tab === 'specs' ? 'active' : ''}`}>
                    <ProductSpecs productCatagory={resProductCatagory} productDetail={productDetail} theme={theme} />
                </div>
            )}
            {changedTab.media && media?.mediaList?.length > 0 && (
                <div className={`tab-container ${tab === 'media' ? 'active' : ''}`}>
                    <ProductMedia langKey={langKey} mediaBanner={media?.mediaBanner} mediaList={media?.mediaList} theme={theme} />
                </div>
            )}
            <style jsx global>
                {`
                    .festival-bar,
                    .announcement-bar {
                        position: relative;
                    }
                `}
            </style>
        </div>
    );
}
